import { render, staticRenderFns } from "./research_literature.vue?vue&type=template&id=17717b36&scoped=true&"
import script from "./research_literature.vue?vue&type=script&lang=js&"
export * from "./research_literature.vue?vue&type=script&lang=js&"
import style0 from "./research_literature.vue?vue&type=style&index=0&id=17717b36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17717b36",
  null
  
)

export default component.exports